import React, { useState } from "react";

import { Link } from "react-router-dom";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { TextInput } from "shared/components/text-input/text-input";
import { FormulaireSubmit } from "./formulaire-submit";
import './formulaire_subStep3.scss';
import { Container, Typography, Box, Button, Tooltip, IconButton } from '@mui/material';
import {
    Resiliation,
    MotifMaintenantSchema,
    motifMaintenantSchema
} from "modules/resiliation/model/resiliation";
import './formulaire.scss';
import ProgressBar from "shared/components/progress-bar/progress-bar";
import { SpbButtonSelect } from "shared/components/spb-button-select/spb-button-select";
import { isMobile } from "react-device-detect";

export interface IFormulaireSubStep3Props {
    resiliation: Resiliation;
    submit: (resiliation: Resiliation) => void;
    cancel: () => void;
}


export const FormulaireSubStep3 = ({
    resiliation,
    submit,
    cancel,
}: IFormulaireSubStep3Props) => {

    const infoIcone: string = require("../../../../assets/infoIcone.svg").default;

    const [selectedButton, setSelectedButton] = useState(null);
    
    const handleClickButton = (value :any) => {
        setSelectedButton(value);
        
    };

   

    const [isTooltipOpen, setTooltipOpen] = useState(false);

    const handleTooltipToggle = () => {
        setTooltipOpen(!isTooltipOpen);
    };

   

    return (
        <div>
            <div className={isMobile ? 'content-mobile' : 'content'} >
                <div className="container-box">
                    <div className="avatar">

                    </div>
                    <Formik
                        initialValues={resiliation.motifMaintenant}
                        validationSchema={motifMaintenantSchema}
                        onSubmit={(values, { setFieldError }) => {
                           
                          
                        const valuescopy={...values}
                        valuescopy.date= values.motif === 'Autre' ?  null :  values.date;
                        valuescopy.description= values.motif === 'Je ne détiens plus le bien assuré' ?  '' :  values.description;
                            submit({ ...resiliation, ...{ motifMaintenant: { ...valuescopy} } });
                        }}
                    >
                        {({ values, errors, touched, handleChange, setFieldValue, handleSubmit }) => {
                          
                          

                            return (


                                <Form>

{errors.motif && touched.motif && (
                                        <div style={{ color: 'red', marginTop:'10px' }}>{errors.motif}</div>
                                    )}

                                    <div className={isMobile ? 'element-containter-mobile' : 'element-containter'} style={isMobile ? { flexDirection: "column" } : {}}>
                                        <div className={isMobile ? 'containter-choice-mobile' : 'containter-choice'} >
                                            <div className="btn-container">
                                                <button
                                                    type="button"
                                                    className={ (values.motif === "Je ne détiens plus le bien assuré" ) ? 'choice-btn selected' : 'choice-btn'}
                                                    onClick={() => { 
                                                        handleChange({ target: { name: 'motif', value: 'Je ne détiens plus le bien assuré' } });
                                                      
                                                    }}
                                                >
                                                    Je ne détiens plus le bien assuré
                                                </button>
                                                {values.motif === 'Je ne détiens plus le bien assuré' && (
                                                    <div className="sub-btn">
                                                        <div className="calendar">
                                                            <label htmlFor="date" className="label">Depuis le :</label>
                                                            <Field type="date" className='input-calendar' id="date" name="date" max={new Date().toISOString().split('T')[0]} />
                                                        </div>
                                                        {errors.date && touched.date && <span style={{ color: 'red' }} >{errors.date === 'Merci de renseigner cette information' ? errors.date : "Merci de renseigner cette information"}</span>}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="btn-container">
                                                <button
                                                    type="button"
                                                    className={ (values.motif  === "Ma situation personnelle a changé" ) ? 'choice-btn selected infoBulle' : 'choice-btn infoBulle'}
                                                    onClick={() => {
                                                        handleChange({ target: { name: 'motif', value: 'Ma situation personnelle a changé' } });
                                                      
                                                    }
                                                    }
                                                >
                                                    Ma situation personnelle a changé
                                                    <Tooltip
                                                        title="Exemples : divorce, mariage, déménagement, perte d'emploi, changement d’emploi, retraite, cessation d'activité commerciale, décès de l'adhérent, etc."
                                                        arrow
                                                        open={isTooltipOpen}
                                                        onClick={handleTooltipToggle} // Gère le clic pour les appareils mobiles
                                                        onMouseEnter={handleTooltipToggle} // Gère le survol de la souris pour les ordinateurs de bureau
                                                        onMouseLeave={handleTooltipToggle} // Gère la sortie du survol de la souris pour les ordinateurs de bureau
                                                    >
                                                        <IconButton className='info-icon info-icon-btn' size="small">
                                                            {/* <InfoIcon /> */}
                                                            <img
                                                                // className={selectedButton1  ? 'info-icon-img icon-selected' : 'info-icon-img'}
                                                                className='info-icon-img'
                                                                src={infoIcone} alt="icone information"
                                                            />
                                                        </IconButton>
                                                    </Tooltip>
                                                </button>
                                                {values.motif === 'Ma situation personnelle a changé' && (
                                                    <div className="sub-btn">
                                                        <div className="calendar" >
                                                            <label htmlFor="date" className="label">Depuis le :</label>
                                                            <Field type="date" className='input-calendar' id="date" name="date" max={new Date().toISOString().split('T')[0]} />
                                                        </div>
                                                        {errors.date && touched.date && <span style={{ color: 'red' }} >{errors.date === 'Merci de renseigner cette information' ? errors.date : "Merci de renseigner cette information"}</span>}
                                                        <div>
                                                            {/* <label htmlFor="description">Champ de saisie libre :</label> */}
                                                            <Field
                                                                as="textarea"
                                                                type="text"
                                                                className='input'
                                                                placeholder='Veuillez préciser le changement qui a eu lieu'
                                                                id="description"
                                                                rows={4}
                                                                name="description"
                                                                maxLength={500}
                                                                minLength={20}
                                                            />
                                                            {errors.description && touched.description && <span style={{ color: 'red' }} >{errors.description}</span>}
                                                        </div>
                                                        <div className="character-count">
                                                            {values.description?.length}/500
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="btn-container">
                                                <button
                                                    type="button"
                                                    className={(values.motif === "Autre" )  ? 'choice-btn selected' : 'choice-btn'}
                                                    onClick={() => {
                                                        handleChange({ target: { name: 'motif', value: 'Autre' } });
                                                        handleClickButton(3);
                                                    }
                                                    }
                                                >
                                                    Autre
                                                </button>
                                                {values.motif === 'Autre' && (
                                                    <div className="sub-btn">
                                                        {/* <label htmlFor="texte">Champ de saisie libre :</label> */}
                                                        <Field
                                                            as="textarea"
                                                            type="text"
                                                            className='input'
                                                            placeholder='Veuillez préciser le motif de votre demande de renonciation ou de résiliation'
                                                            id="description"
                                                            rows={4}
                                                            name="description"
                                                            maxLength={500}
                                                            minLength={20}
                                                        />
                                                        <div className="character-count">
                                                            {values.description?.length}/500
                                                        </div>
                                                        {errors.description && touched.description && <span style={{ color: 'red' }}>{errors.description}</span>}
                                                    </div>

                                                )}
                                            </div>
                                        </div>
                                    </div>
                                 
                                    <FormulaireSubmit previous={() => cancel()} />

                                </Form>)

                        }

                        }

                    </Formik>

                </div>
            </div>
        </div >)
}


